export const userSelect 				= (state) => state.auth.user;
export const originalFinanceSelect 		= (state) => state.finance.homescreenstat;
export const homeScreenStatSelect 		= (state) => {
    const stats = state.finance.homescreenstat;
    if (!stats || stats.length <= 1) return stats;
    let activeType = localStorage.getItem('activeCurrencyType');
    if (!activeType) {
        activeType = '148';
    }
    const activeIndex = stats.findIndex(s => String(s.type) === String(activeType));
    if (activeIndex <= 0) return stats;
    const reordered = [...stats];
    const [activeItem] = reordered.splice(activeIndex, 1);
    reordered.unshift(activeItem);
    return reordered;
};
export const allEscrowSelect 			= (state) => state.escrow.allescrow;
export const allDepositSelect 			= (state) => state.deposit.depositdata;
export const allTradeSelect 			= (state) => state.trade.trades;
export const allWithdrawalSelect 		= (state) => state.withdrawal.withdrawaldata;
export const allRemoteSettingsSelect 	= (state) => state.settings.settings;
export const allFXSelect 				= (state) => state.fx.fxhead;
export const notificationSelect 		= (state) => state.notify.data;
export const exchangeSelect 			= (state) => state.exchanger.data;